if (!customElements.get("shop-the-look-drawer")) {
  class ShopTheLookDrawer extends HTMLElement {
    constructor() {
      super();
      if (Shopify.designMode) {
        window.addEventListener("shopify:section:load", this.init.bind(this));
      }
      this.init();
    }

    init() {
      this.toggleState = false;
      
      // Remove any existing event listeners to prevent duplicates
      this.cleanup();
      
      if (!this.classList.contains("is--open")) {
        document.querySelector("body").classList.remove("overflow-hidden");
      }
      
      // Close button for this specific drawer
      this.querySelector(".button--close").addEventListener("click", this.close.bind(this));
      this.querySelector(".shop-the-look-drawer__backdrop").addEventListener("click", this.close.bind(this));
      
      // Find triggers that specifically control THIS drawer
      const drawerId = this.id;
      const triggers = document.querySelectorAll(`[aria-controls="${drawerId}"]`);
      
      triggers.forEach(trigger => {
        trigger.addEventListener("click", (event) => {
          event.preventDefault();
          this.closeAllOtherDrawers();
          this.open();
        });
      });
    }

    cleanup() {
      // Remove event listeners to prevent duplicates
      const closeBtn = this.querySelector(".button--close");
      const backdrop = this.querySelector(".shop-the-look-drawer__backdrop");
      
      if (closeBtn) {
        closeBtn.replaceWith(closeBtn.cloneNode(true));
      }
      if (backdrop) {
        backdrop.replaceWith(backdrop.cloneNode(true));
      }
    }

    closeAllOtherDrawers() {
      document.querySelectorAll("shop-the-look-drawer.is--open").forEach(drawer => {
        if (drawer !== this) {
          drawer.close();
        }
      });
    }

    toggle() {
      if (!this.toggleState) {
        this.closeAllOtherDrawers();
        this.open();
      } else {
        this.close();
      }
    }

    open() {
      this.toggleState = true;
      document.querySelector("body").classList.add("overflow-hidden");
      this.classList.add("is--open");
    }

    close() {
      this.toggleState = false;
      document.querySelector("body").classList.remove("overflow-hidden");
      this.classList.remove("is--open");
      this.toggleAriaExpanded();
    }

    toggleAriaExpanded(event) {
      const drawerId = this.id;
      const triggers = document.querySelectorAll(`[aria-controls="${drawerId}"]`);
      
      if (this.toggleState) {
        // Opening - set aria-expanded="true" on all triggers for this drawer
        triggers.forEach(button => {
          button.setAttribute("aria-expanded", "true");
        });
      } else {
        // Closing - set aria-expanded="false" on all triggers for this drawer
        triggers.forEach(button => {
          button.setAttribute("aria-expanded", "false");
        });
      }
    }
  }

  customElements.define("shop-the-look-drawer", ShopTheLookDrawer);
}